import React, { FunctionComponent } from 'react';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { moderateScale } from 'react-native-size-matters';
import Theme from '../../../theme';
import { defaultScale, fullScale } from '../../../utils/scaling';

interface IProps {
  icon: React.ReactNode;
  label: string;
  onPress: () => void;
  disabled?: boolean;
  small?: boolean;
  loading?: boolean;
}

export const disabledOpacity = 0.57;

export const IconButton: FunctionComponent<IProps> = ({
                                                        icon,
                                                        label,
                                                        onPress,
                                                        disabled = false,
                                                        small = false,
                                                        loading = false,
                                                      }) => {
  return (
    <TouchableOpacity onPress={onPress} style={[styles.container, small && styles.containerSmall]}
                      disabled={disabled || loading}>
      <View style={styles.iconContainer}>
        {
          loading &&
          <ActivityIndicator size='small' color={Theme.WHITE} animating />
        }
        {
          !loading && icon
        }
      </View>
      <Text style={[styles.label, disabled && styles.disabledLabel]}>{label}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    width: moderateScale(90),
    height: moderateScale(80),
    alignItems: 'center',
  },
  containerSmall: {
    width: defaultScale(90),
  },
  iconContainer: {
    height: defaultScale(40),
    justifyContent: 'center',
  },
  label: {
    ...Theme.textStyle.bodyCopyReg,
    fontSize: moderateScale(12, 0.75),
    color: Theme.WHITE,
    textAlign: 'center',
  },
  disabledLabel: {
    opacity: disabledOpacity,
  },
});
